var _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _ellipse2, _ellipse3, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse4, _ellipse5, _ellipse6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLidapLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.77747,
    cy: 8.75,
    rx: 3.77747,
    ry: 3.75,
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.62012,
    y: 5,
    width: 25.3405,
    height: 2.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.665,
    y: 10,
    width: 20,
    height: 2.51831,
    transform: "rotate(90 22.665 10)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6279,
    y: 10,
    width: 20,
    height: 2.51831,
    transform: "rotate(90 17.6279 10)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4424,
    y: 2.5,
    width: 20.1465,
    height: 2.5,
    transform: "rotate(-180 26.4424 2.5)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5918,
    y: 10,
    width: 20,
    height: 2.51831,
    transform: "rotate(90 12.5918 10)",
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9601,
    cy: 8.75,
    rx: 3.77746,
    ry: 3.75,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.77747,
    cy: 8.75,
    rx: 3.77747,
    ry: 3.75,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.62012,
    y: 5,
    width: 25.3405,
    height: 2.5,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.665,
    y: 10,
    width: 20,
    height: 2.51831,
    transform: "rotate(90 22.665 10)",
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6279,
    y: 10,
    width: 20,
    height: 2.51831,
    transform: "rotate(90 17.6279 10)",
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4424,
    y: 2.5,
    width: 20.1465,
    height: 2.5,
    transform: "rotate(-180 26.4424 2.5)",
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5918,
    y: 10,
    width: 20,
    height: 2.51831,
    transform: "rotate(90 12.5918 10)",
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.77771,
    cy: 8.75,
    rx: 1.25916,
    ry: 1.25,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9601,
    cy: 8.75,
    rx: 3.77746,
    ry: 3.75,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9603,
    cy: 8.75,
    rx: 1.25916,
    ry: 1.25,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLidapLogo);
export default __webpack_public_path__ + "static/media/LidapLogo.25464739f8a2821c9b77cc0c454e6eeb.svg";
export { ForwardRef as ReactComponent };